module.exports = __webpack_public_path__ + "img/spatial.e2537edd.png";